import type { CollectionModel } from "@/features/collections/api/models/CollectionModel";
import type { CollectionSortOrder } from "@/features/collections/CollectionSortOrder";
import { useHTTP } from "@/lib/http";
import { useHTTPQueryWithCursor } from "@/lib/http/useHTTPQueryWithCursor";

export const useCollections = (sortOrder: CollectionSortOrder, filterQuery: string | null) => {
	const http = useHTTP("Required");
	return useHTTPQueryWithCursor<CollectionModel>({
		queryKey: ["collections", sortOrder, filterQuery],
		queryFn: ({ pageParam = 0 }) => {
			return http({
				method: "GET",
				url: `/collection?cursor=${pageParam}&sort=${sortOrder}` + (filterQuery ? `&filterQuery=${encodeURIComponent(filterQuery)}` : "")
			});
		}
	});
};
